// extracted by mini-css-extract-plugin
export var container = "_79-0";
export var error = "_79-9";
export var label = "_79-5";
export var light = "_79-6";
export var md = "_79-3";
export var sm = "_79-2";
export var thin = "_79-8";
export var thinBold = "_79-7";
export var vertical = "_79-4";
export var xs = "_79-1";